import { GAME_ART } from './GameCard.js';

// brandColor is admin-entered and lands in an inline style — only a bare hex gets through.
const HEX_COLOR = /^#(?:[0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i;

export function providerArtBackground(brandColor: string | null | undefined): string {
  return brandColor && HEX_COLOR.test(brandColor)
    ? `linear-gradient(160deg, ${brandColor} 0%, var(--bg-raised) 100%)`
    : GAME_ART.slot;
}

export type LogoFit = 'fill' | 'mark';

/**
 * A camp logo is either an art tile that carries its own background (3:4 as
 * the backoffice crops it now, square from before) or a bare wordmark. The art
 * tile fills the 3:4 card; shrinking it to a wordmark's size leaves a small
 * stamp floating in an empty card, and cropping a wordmark to fill would cut
 * its letters.
 */
export function logoFit(width: number, height: number): LogoFit {
  if (width <= 0 || height <= 0) return 'fill';
  const ratio = width / height;
  return ratio >= 0.7 && ratio <= 1.25 ? 'fill' : 'mark';
}
